export const plex = {
  name: 'Plex',
  id: 'plex',
  url: 'https://www.plex.tv/',
  color: '#494949',
  compatible: false
}
